import { h, Component, Fragment } from 'preact';
import classNames from 'classnames';


const UNRENDERABLE = '-';

const _adaptPrice = (price, currency) => {
  if (currency === 'USD') {
    return `$${price}`;
  } else {
    return UNRENDERABLE;
  }
}

const _adaptPriceMovement = (priceMovement) => {
  // TODO: Edge case with no change, 0.
  return <span class={classNames({
    't-text-mitre-red-200': priceMovement[0] === '-',
    't-text-mitre-green-200': priceMovement[0] !== '-' })}>{priceMovement}</span>;
};

const _standardTwoLineThContents = (line1, line2) => {
  return <Fragment>
    <p>{line1}</p>
    <p>{line2}</p>
  </Fragment>;
};

const _standardTwoLineTdContents = (line1, line2) => {
  return <Fragment>
    <p class="t-text-lg">{line1}</p>
    <p class="t-text-sm">{line2}</p>
  </Fragment>;
};

const thNetAssetsMktCapRenderer = (colName) => {
  return _standardTwoLineThContents(
    "Net Assets",
    "MKT Cap"
  );
};

const tdNameRenderer = (data) => {
  if (typeof data === 'object') {
    const { name, ticker, securityType, secondaryType, pageUrl } = data;
    const secondLineParts = [ticker, securityType, secondaryType].filter((one) => Boolean(one));
    return _standardTwoLineTdContents(
      <a href={pageUrl}>{name}</a>,
      secondLineParts.join(' | ')
    );
  } else if (typeof data === 'string') {
    return data;
  } else {
    return UNRENDERABLE;
  }
};

const tdPriceRenderer = (data) => {
  if (typeof data === 'object') {
    const { priceAmount, priceCurrency, priceMovement } = data;
    return _standardTwoLineTdContents(
      _adaptPrice(priceAmount, priceCurrency),
      _adaptPriceMovement(priceMovement)
    );
  } else {
    return UNRENDERABLE;
  }
};

const thContentsRenderers = {
  default: (data) => data.toString(),
  "Name": (data) => data,
  NetAssetsMktCap: thNetAssetsMktCapRenderer,
};

const tdContentsRenderers = {
  default: (data) => data.toString(),
  "Name":  tdNameRenderer,
  "Price": tdPriceRenderer,
  "NetAssetsMktCap": ({ amount, currency }) => _adaptPrice(amount, currency),
};


class SmoothTable extends Component {

  render() {
    if (!this.props.data) return null;

    const { headers, rows } = this.props.data;

    return <Fragment>
      <table class="smooth-table">
        <caption>
          This is a table caption.
        </caption>
        <colgroup>
          {headers.map((data) => <col />)}
        </colgroup>
        <thead data-controller="sticky" data-sticky-index="2" data-sticky-target="stuck">
          <tr>
            {headers.map((colName) => <th>{this.constructor.renderThContents(colName)}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((rowData) => <tr>
            {rowData.map((colValue, colIdx) => <td>{this.constructor.renderTdContents(headers[colIdx], colValue)}</td>)}
          </tr>)}
        </tbody>
      </table>
    </Fragment>;
  }

  static renderThContents(colName) {
    const thContentsRenderer = thContentsRenderers[colName] || thContentsRenderers.default;
    return thContentsRenderer(colName);
  }

  static renderTdContents(colName, colValue) {
    const tdContentsRenderer = tdContentsRenderers[colName] || tdContentsRenderers.default;
    return tdContentsRenderer(colValue);
  }
}

export default SmoothTable;
